/**
 * @generated SignedSource<<8be8ff24350e5100b0a3d9bb1df57aca>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CancelAccount_walletBalance$data = {
  readonly amount: {
    readonly formatted: string;
  };
  readonly " $fragmentType": "CancelAccount_walletBalance";
};
export type CancelAccount_walletBalance$key = {
  readonly " $data"?: CancelAccount_walletBalance$data;
  readonly " $fragmentSpreads": FragmentRefs<"CancelAccount_walletBalance">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CancelAccount_walletBalance",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CurrencyAmount",
      "kind": "LinkedField",
      "name": "amount",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "formatted",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "WalletBalance",
  "abstractKey": null
};

(node as any).hash = "36cab127c9c08f814302de35ad5a086f";

export default node;
